import { BUILTIN_A_ASSET } from './builtinAssets.js';
import { LIBRARY_RECORDINGS } from './library.js';
import { METHOD_SPECS } from './methods.js';
/** Leesbare licentienaam (SPDX-achtig → "CC BY-SA 4.0"). */
export function licenseLabel(spdx) {
    if (spdx === 'CC0-1.0')
        return 'CC0 1.0';
    const m = /^CC-(BY(?:-SA)?)-(\d\.\d)$/.exec(spdx);
    return m ? `CC ${m[1]} ${m[2]}` : spdx;
}
const BUILTIN_A = {
    id: 'builtin_a',
    region: 'arabic',
    place: null,
    year: 2022,
    fajr: 'no',
    tradition: 'sunni',
    title: BUILTIN_A_ASSET.source.title,
    author: BUILTIN_A_ASSET.source.author,
    platform: 'Wikimedia Commons',
    page: BUILTIN_A_ASSET.source.page,
    license: BUILTIN_A_ASSET.source.license,
    licenseUrl: BUILTIN_A_ASSET.source.licenseUrl,
    outputLicense: BUILTIN_A_ASSET.source.license,
    shareAlike: false,
    modified: 'Luidheid −16 LUFS, AAC mono 48 kbit/s en MP3; verder niet bewerkt',
    durationS: BUILTIN_A_ASSET.durationS,
    path: BUILTIN_A_ASSET.m4a.path,
};
/** Alle meegeleverde opnames, in de volgorde van de kiezer (de standaard eerst). */
export const RECORDING_CATALOG = [
    BUILTIN_A,
    ...LIBRARY_RECORDINGS.map((r) => ({
        id: r.id,
        region: r.region,
        place: r.place,
        year: r.year,
        fajr: r.fajr,
        tradition: r.tradition,
        title: r.title,
        author: r.author,
        platform: r.platform,
        page: r.page,
        license: r.license,
        licenseUrl: r.licenseUrl,
        outputLicense: r.outputLicense,
        shareAlike: r.shareAlike,
        modified: r.modified,
        durationS: r.durationS,
        path: r.asset.path,
    })),
];
/** Volgorde van de regiogroepen in de kiezer. */
export const RECORDING_REGIONS = [
    'arabic',
    'hijaz',
    'turkish',
    'maghreb',
    'egypt',
    'levant',
    'southeast_asia',
    'central_asia',
    'europe',
    'other',
];
/** De opname met deze id, of null (ook voor `builtin_b`: niet meegeleverd). */
export function catalogRecording(id) {
    for (const r of RECORDING_CATALOG)
        if (r.id === id)
            return r;
    return null;
}
/** Bestaat deze id in het contract (ook `builtin_b`, dat de API weigert)? */
export function isBuiltinRecordingId(id) {
    return id === 'builtin_b' || catalogRecording(id) !== null;
}
/** Mag deze meegeleverde opname bij Fajr klinken (een ochtendopname, nagekeken of niet)? */
export function fitsFajr(id) {
    const r = catalogRecording(id);
    return !!r && r.fajr !== 'no';
}
/** Het eigen gebedsbelletje: een ander geluid dan de taakbelletjes, even luid als de opnames. */
export const PRAYER_TONE_ID = 'tone';
/**
 * Standaardopname: de eerste ingebouwde opname voor soennitische methoden; bij Jafari het
 * belletje (onze opnames hebben de soennitische tekst) tot de ouder een eigen opname kiest.
 */
export function defaultRecording(method) {
    return METHOD_SPECS[method].tradition === 'shia'
        ? { kind: 'tone' }
        : { kind: 'builtin', id: 'builtin_a' };
}
/** Past een ingebouwde opname bij de methode? (Jafari: nee, de API weigert die combinatie.) */
export function builtinFitsMethod(method) {
    return METHOD_SPECS[method].tradition === 'sunni';
}
/** Grenzen van een eigen opname (upload; alleen AAC/MP3, iOS 12 speelt geen Ogg/Opus). */
export const UPLOAD_AUDIO_MAX_BYTES = 5 * 1024 * 1024;
export const UPLOAD_AUDIO_MAX_SECONDS = 5 * 60;
export const UPLOAD_AUDIO_MIME = ['audio/mp4', 'audio/aac', 'audio/mpeg'];
//# sourceMappingURL=recordings.js.map